import { defineStore } from "pinia";
import http from "@/http";
import { LIST_IMAGEM, ADD_IMAGEM, UPDATE_IMAGEM, DEL_IMAGEM } from "@/http/url";

export const useImagemStore = defineStore("ImagemStore", {
  state: () => {
    return {
      imagens: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_IMAGENS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_IMAGEM)
          .then((response) => {
            this.imagens = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_IMAGEM(imagem) {
      return http
        .post(ADD_IMAGEM, imagem)
        .then((response) => this.imagens.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_IMAGEM(imagem) {
      return http.put(`${UPDATE_IMAGEM + imagem.id}`, imagem);
    },

    REMOVER_IMAGEM(id) {
      return http
        .delete(`${DEL_IMAGEM + id}`)
        .then(() => (this.imagens = this.imagens.filter((img) => img.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getImagens() {      
      return this.imagens;
    },

    getImagemLoad(state) {
      return state.loaded;
    },

    getFilterImagens: (state) => {
      return (filtro) => state.imagens.filter((i) => !filtro || i.descricao.includes(filtro));
    },
  },
});